import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppProvider } from './AppContext';
import AppRoutes from './AppRoutes';

const App: React.FC = () => {
  return (
    <AppProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
};

export default App;
